///
/// EarthBrowser
///
/// Created by Matt Giger on 12/5/2025
/// Copyright (c) 2025 Geodata Labs
///

import { type EarthBrowserContext } from "@/earthbrowser/EarthBrowserContext"
import { TapGestureRecognizer } from "@stovokor/gestures/TapGestureRecognizer"

export class EntityTapHandler extends TapGestureRecognizer {
	private context: EarthBrowserContext

	constructor(context: EarthBrowserContext, priority: number = 20) {
		super({
			maximumTouches: 1 // Fail if second finger touches (for pinch-to-zoom)
		})
		this.context = context
		this.priority = priority

		this.onGesture(() => {
			// Restricted contexts (embeds) limit which entities a tap may focus
			if (this.owner && this.context.canFocusEntity(this.owner)) {
				this.context.focusManager.requestFocus(this.owner)
			}
		})
	}
}